import { NavigationService } from '../../../../../../services/navigation.service';
import {
  Component, ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges, ViewChild
} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject, Subscription} from 'rxjs';
import { PostMessageService } from 'src/app/modules/shared/services/post-message.service';
import { IHolidayDetail } from '../../interfaces/iholiday-detail';
import { WidgetService } from '../../../../../shared/services/widget.service';
import { IHolidayDetailSolution } from '../../interfaces/iholiday-detail-solution';
import {LoadingService} from '../../../../../shared/services/loading.service';
import {Networks} from '../../../../../shared/models/networks.enum';
import {CmsService} from '../../../../../cms/services/cms.service';
import {EngineGuestsModalComponent} from '../../../../../search-engine/components/engine-guests-modal/engine-guests-modal.component';
import {BookingService} from '../../../../../shared/services/booking.service';
import {LocationService} from '../../../../../shared/services/location.service';
import {takeUntil} from 'rxjs/operators';
import {HolidayBookingService} from '../../../holiday-booking-page/services/holiday-booking.service';

@Component({
  selector: 'app-detail-content-aside',
  templateUrl: './detail-content-aside.component.html',
  styleUrls: ['./detail-content-aside.component.scss']
  })

export class DetailContentAsideComponent implements OnInit, OnChanges, OnDestroy {

  @Input() holidayDetails: IHolidayDetail;
  @Input() bookingUrl: string;
  @Input() selectedSolution: IHolidayDetailSolution;
  @Input() formattedGuestsString: string;
  @Input() destinationName: string;
  @Input() isLanding: boolean;
  @Input() noAvailability: boolean = false;

  @ViewChild('editGuestsRef') editGuestsRef: ElementRef;

  public isWidget$: Observable<boolean>;
  public isWidget: boolean;
  public isB2B$: Observable<boolean>;
  public detailUrl: Observable<string>;
  public location = encodeURIComponent(location.href);

  private unsubscribe$ = new Subject();

  public loadingStatus = false;
  public loadingMessage = '';

  public wtgNetworkId: number;
  public brand: any;

  private isWidgetSubscription: Subscription;
  private classicLoadingStatusSubscription: Subscription;
  private brandConfigSubscription: Subscription;

  constructor(
    private _widgetService: WidgetService,
    private _navigationService: NavigationService,
    private _postMessageService: PostMessageService,
    private _loadingService: LoadingService,
    private _cmsService: CmsService,
    private _modalService: NgbModal,
    private _bookingService: BookingService,
    private _locationService: LocationService,
    private _holidayBookingService: HolidayBookingService
  ) {
    this.wtgNetworkId = Networks.WTG;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bookingUrl && this.bookingUrl) {
      this._navigationService.getRedirectUrl(this.bookingUrl).then(
        (resolved) => {
          this.bookingUrl = resolved.url;
          this.isWidget = resolved.isWidget;
        }
      );
    }
  }

  ngOnInit(): void {
    this.isWidget$ = this._widgetService.isWidget();
    this.isB2B$ = this._postMessageService.isB2B();
    this.detailUrl = this._locationService.getCurrentHref();
    if(!this.noAvailability){
      this._holidayBookingService.holidayDetailLoadingStatus$
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((loadingStatus) => {
        this.loadingStatus = loadingStatus.isLoadingDetail || loadingStatus.isLoadingLivePrices || loadingStatus.isDebounceing;
        this.loadingMessage = 'Stiamo aggiornando il tuo preventivo...';
      });

    this.classicLoadingStatusSubscription = this._loadingService.getClassicLoadingStatus()
      .subscribe((status) => {
        this.loadingStatus = status;
        this.loadingMessage = 'Stiamo aggiornando il tuo preventivo...';
      });
    }

    this.brandConfigSubscription = this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) {
        this.brand = brand;
      }
    });
  }

  ngOnDestroy(): void {
    this.classicLoadingStatusSubscription?.unsubscribe();
    this.brandConfigSubscription?.unsubscribe();
  }

  scrollToOptions(){
    const optionsElement = document.querySelector('detail-flight');
    if (this.isWidget && optionsElement) {
      const targetElementPosition = optionsElement.getBoundingClientRect();
      if (!targetElementPosition) {
        return;
      }
      const positionToScroll = targetElementPosition.top + window.pageYOffset;

      // effettuo lo scroll del parent
      this._postMessageService.scrollToElementPos(positionToScroll);
    } else if (optionsElement) {
      optionsElement.scrollIntoView({behavior: 'smooth'});
    }
  }

  public openEngineGuestsModal(): void {
    setTimeout(() => {
      // effettuo uno scroll verso il link "Modifica passeggeri" in modo da visualizzare nella posizione corretta la modale
      if (this.isWidget) {
        const targetElementPosition = document.querySelector('.holiday-guests')?.getBoundingClientRect();
        if (!targetElementPosition) {
          return;
        }
        const positionToScroll = targetElementPosition.top + window.pageYOffset;

        // effettuo lo scroll del parent
        this._postMessageService.scrollToElementPos(positionToScroll);
      } else {
        this.editGuestsRef?.nativeElement.scrollIntoView();
      }
    }, 250);
    const engineGuestsModalRef = this._modalService.open(
        EngineGuestsModalComponent,
        {
          ariaLabelledBy: 'modal-engine',
          size: 'lg'
        }
    );
    engineGuestsModalRef.componentInstance.isOpenIntoDetailPage = true;
    engineGuestsModalRef.componentInstance.selectedGuests.subscribe(
        (occupancy) => {
          // aggiorno il dettaglio holiday con l'occupancy appena modificato dalla modale
          // NB: viene eseguito prima un controllo se ci sono disponibilità per le età inserite e in caso, riesegue
          // la chiamata del dettaglio con le nuove età dei passeggeri
          this._bookingService.setNewAges(occupancy.ages);
        }
    );
  }

  public onClickOnChooseSolution() {
    document.querySelector('#solutionsList')?.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
